import { render, staticRenderFns } from "./UserDeactivated.vue?vue&type=template&id=b8d5884a&scoped=true"
import script from "./UserDeactivated.vue?vue&type=script&lang=js"
export * from "./UserDeactivated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d5884a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8d5884a')) {
      api.createRecord('b8d5884a', component.options)
    } else {
      api.reload('b8d5884a', component.options)
    }
    module.hot.accept("./UserDeactivated.vue?vue&type=template&id=b8d5884a&scoped=true", function () {
      api.rerender('b8d5884a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UserDeactivated.vue"
export default component.exports